function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "animate",
  d: "M-1011.1,1505.3h-2500v-2500h2500V1505.3z M-3442.3,1438.5h2363.5V-927.9h-2363.5V1438.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "animate",
  d: "M-1313,858V130.9c0-219.8-335.7-367.1-756-195.7v922.7h248.8V63.3c130.4-43.5,282.6-24.2,282.6,87V858H-1313z  M-2561.8-487.5h-270.6l-372,1330.9l207.7,12.1l101.4-374.4h398.6l99,374.4h239.1L-2561.8-487.5z M-2842,271l140.1-558l147.3,558 H-2842z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "animate",
  d: "M0,0v512h512V0H0z M482,482H30V30h452V482z"
})));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "animate",
  d: "M402.1,340.8v-91.6c0-27.7-51.9-46.3-116.8-24.7v116.3h38.4V240.6c20.1-5.5,43.7-3.1,43.7,11v89.2H402.1z  M209.2,171.2h-41.8L109.9,339l32.1,1.5l15.7-47.2h61.6l15.3,47.2h36.9L209.2,171.2z M165.9,266.8l21.6-70.3l22.8,70.3H165.9z"
});

function SvgAnimate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimate);
export default __webpack_public_path__ + "static/media/animate.e83558ce.svg";
export { ForwardRef as ReactComponent };